import React from 'react';
import Accordion from 'components/Accordion';
import { faqsContent } from 'routes/faqs/content/faqsContent';

const FAQsSection = () => {
    return (
        <>
            <div className='font-bold text-4xl text-base-100 text-center'>Frequently Asked Questions</div>
            <Accordion content={faqsContent} collapseOpen={true} />
        </>
    );
}

export default FAQsSection;
